export enum AuditCompanyInformationFormNamesEnum {
  FORM_GROUP_NAME = 'AuditCompanyInformation',
  SAME_AS = 'SameAsClaimant',
  MATCH = 'Match',
  CLEAR = 'Clear',
  DO_NOT_MATCH_IND = 'doNotMatchInd',
  MATCHED = 'matched',
}
